import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { PasswordResetSentPage } from '../password-reset-sent/password-reset-sent';

@Component({
  selector: 'page-password-recovery',
  templateUrl: 'password-recovery.html'
})
export class PasswordRecoveryPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToPasswordResetSent(params){
    if (!params) params = {};
    this.navCtrl.push(PasswordResetSentPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/password-recovery/password-recovery.ts